import { FC } from 'react';
import { Button } from 'react-daisyui';

type DeleteUserModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName: string;
  userType: 'carer' | 'family member';
  isLoading?: boolean;
  error?: string | null;
};

const DeleteUserModal: FC<DeleteUserModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  userType,
  isLoading = false,
  error = null,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
        <h2 className="text-xl font-bold mb-4">Delete {userType === 'carer' ? 'Carer' : 'Family Member'}</h2>
        <p className="text-gray-600 mb-2">
          Are you sure you want to permanently delete <span className="font-semibold">{userName}</span>'s account?
        </p>
        <p className="text-sm text-red-500 mb-6">
          This action cannot be undone. All associated data will be removed.
        </p>
        {error && (
          <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2 mb-4">{error}</p>
        )}
        <div className="flex gap-3 justify-end">
          <Button
            onClick={onClose}
            disabled={isLoading}
            className="bg-white text-black border border-gray-300 hover:bg-gray-50 rounded-lg"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-[#FF5861] text-white border-none hover:opacity-80 rounded-lg"
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserModal;
